import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { AuthProvider } from 'react-auth-kit'
import { BrowserRouter as Router } from 'react-router-dom'
import ErrorBoundary from "./ErrorBoundary";
import { applyInlineThemeReplacements, applyThemeVariables } from './config/theme'
import { ThemeProvider, useTheme } from './contexts/ThemeContext'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'

// Step 1: Apply theme variables before React renders
applyThemeVariables()

// Step 2: Apply inline theme replacements after DOM ready
applyInlineThemeReplacements()

// Wrapper component to access theme context and provide MUI theme
const AppWithTheme = () => {
  const { muiTheme } = useTheme();
  
  return (
    <MuiThemeProvider theme={muiTheme}>
      <AuthProvider
        authType="cookie"
        authName="_auth"
        cookieDomain={window.location.hostname}
        cookieSecure={false}
      >
        <Provider store={store}>
          <Router>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </Router>
        </Provider>
      </AuthProvider>
    </MuiThemeProvider>
  );
};

// Step 3: Render React application with ThemeProvider wrapping everything
createRoot(document.getElementById('root')).render(
  <ThemeProvider>
    <AppWithTheme />
  </ThemeProvider>
)

reportWebVitals()
